import { FC } from 'react'
import UpdateBulk from '../../modules/products/UpdateBulk'

// No useCheckPendingBulk here — see AddProductBulkPage. The hook is a DISCOUNT
// gate; on a product page it redirected into /discount/add-discount-bulk.
const UpdateProductBulkPage:FC = () => {
  return (
    <>
        {/* begin::Row */}
        <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
            <UpdateBulk />
        </div>
        {/* end::Col */}
        </div>
        {/* begin::Row */}
    </>
  )
}

export default UpdateProductBulkPage